import React from 'react';
import { Card, Tag, Typography, Space } from 'antd';
import { TeamOutlined, WarningOutlined, ThunderboltOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SlotCard = ({ slot, selected, onClick }) => {
  const getScoreBadge = (score) => {
    if (score >= 120) return { color: '#059669', label: 'Excellent' };
    if (score >= 100) return { color: '#0284c7', label: 'Bon' };
    if (score >= 80) return { color: '#ea580c', label: 'Moyen' };
    return { color: '#6b7280', label: 'Faible' };
  };

  const scoreBadge = getScoreBadge(slot.score);

  return (
    <Card
      hoverable
      size="small"
      onClick={onClick}
      style={{
        borderColor: selected ? '#059669' : '#e5e7eb',
        background: selected ? '#ecfdf5' : 'white',
        cursor: 'pointer',
      }}
      styles={{ body: { padding: '12px 16px' } }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Space size={12}>
          <div style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: slot.equipe_couleur || '#ecfdf5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <TeamOutlined style={{ color: 'white', fontSize: 16 }} />
          </div>
          <div>
            <Text strong style={{ fontSize: 13 }}>{slot.equipe_nom}</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {slot.heure} — {slot.depot_nom}
            </Text>
          </div>
        </Space>

        <Space size={4}>
          {slot.distance_warning && (
            <Tag icon={<WarningOutlined />} color="warning" style={{ margin: 0 }}>
              {slot.distance_km ? `${slot.distance_km}km` : '>100km'}
            </Tag>
          )}
          <Tag
            icon={<ThunderboltOutlined />}
            color={scoreBadge.color}
            style={{ margin: 0, fontWeight: 600 }}
          >
            {Math.round(slot.score)}
          </Tag>
        </Space>
      </div>
    </Card>
  );
};

export default SlotCard;
